import { render, staticRenderFns } from "./AdminTags.vue?vue&type=template&id=47bd9de5&"
import script from "./AdminTags.vue?vue&type=script&lang=js&"
export * from "./AdminTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports